import { render } from "./EditAttendance.vue?vue&type=template&id=2466a10d&scoped=true"
import script from "./EditAttendance.vue?vue&type=script&lang=js"
export * from "./EditAttendance.vue?vue&type=script&lang=js"

import "./edit-attendance.scss?vue&type=style&index=0&id=2466a10d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2466a10d"]])

export default __exports__